<template>
    <div class="viewpoints-wrap">
        <Title v-if="page">
            <h2>What we do</h2>
        </Title>
        <div class="page-inner">
            <div class="list" v-if="posts.length !== 0">
                <h2 class="title">
                    <router-link to="/case-studies" id="case-studies-page"
                        >Case studies</router-link
                    >
                </h2>
                <Item
                    v-for="(item, index) in posts"
                    :key="item.id + '-' + index"
                    :item="item"
                />
            </div>
            <NoResults v-if="posts.length === 0 && !$store.state.is_loading">
                No posts ...
            </NoResults>
            <PostNewsletter :is_contact="true" v-if="page" />
            <!-- <RelatedLinks v-if="page && page.clients && page.clients.length !== 0" :title="page.list_title" :list="page.clients" /> -->
            <RelatedItems
                v-if="
                    page &&
                        page.related_items &&
                        page.related_items.length !== 0
                "
                :list="page.related_items"
            />
        </div>
        <Loading v-if="$store.state.is_loading" class="static" />
    </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import NoResults from "@/components/ui/NoResults.vue";
import Item from "@/components/Item2.vue";
import Loading from "@/components/Loading.vue";
import RelatedItems from "@/components/RelatedItems.vue";
import RelatedLinks from "@/components/RelatedLinks.vue";
import PostNewsletter from "@/components/PostNewsletter.vue";

export default {
    name: "case-studies",

    data() {
        return {
            page: false,
            posts: [],
            categories: [],
            paged: 1,
            per_page: 999,
            is_end: false
        };
    },

    components: {
        Title,
        Item,
        Loading,
        NoResults,
        PostNewsletter,
        RelatedItems,
        RelatedLinks
    },

    watch: {
        "$route.params": {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true
        }
    },

    methods: {
        getPosts(is_next = false) {
            if (!is_next) {
                this.paged = 1;
                this.posts = [];
                this.is_end = false;
            } else if (this.is_end) return;
            else this.paged++;

            this.$store.state.is_loading = true;

            let url = `get-cases?per_page=${this.per_page}&paged=${this.paged}`;

            this.$ajax
                .get(url)
                .then(res => {
                    if (is_next) {
                        res.data.forEach(item => {
                            this.posts.push(item);
                        });
                    } else {
                        this.posts = res.data;
                    }

                    this.$store.state.is_loading = false;
                    this.is_end = res.data.length < this.per_page;
                })
                .catch(error => {
                    // console.log(error)
                    this.is_end = true;
                });
        },

        fetchData(params) {
            this.page = false;
            // this.current_page_id = false;

            this.$ajax.get("pages?slug=case-studies").then(res => {
                this.page = res.data[0];

                document.title =
                    window.globals.site_title +
                    " — " +
                    this.$decode(res.data[0].title.rendered);
            });

            this.getPosts();
        }
    }
};
</script>

<style lang="scss" scoped>
.list {
    padding: 0 var(--padding-x2) 0 var(--margin);
    margin-top: var(--padding);

    .title {
        font-size: var(--large-size);
        padding-bottom: var(--padding-50);
    }
}

@media only screen and (max-width: 767px) {
    .page-cases-page .page-title {
        margin: 0 var(--padding) 0;
    }
    .list {
        padding: 0;
        margin: 0 0 var(--padding-x3);

        .title {
            font-size: var(--title-size);
        }
    }
}
</style>
